<template>
    <div>

        <b-alert
                :show="dismissCountDown"
                dismissible
                fade
                :variant="variantAlert"
                @dismiss-count-down="countDownChanged"
        >
            {{ textAlert }}
        </b-alert>

        <!--begin::Notice-->
        <b-alert
                show
                variant="light"
                class="alert alert-custom alert-white alert-shadow fade show gutter-b"
        >
            <div class="alert-icon">
        <span class="svg-icon svg-icon-lg">
          <inline-svg src="media/svg/icons/Tools/Compass.svg" />
        </span>
            </div>
            <div class="alert-text">
                <b>Аккаунт</b> На этой странице можно редактировать данные аккаунта
            </div>
        </b-alert>
        <!--end::Notice-->


        <div class="row">
            <div class="col-md-6">
                <div class="card card-custom gutter-b">
                    <div class="card-header">
                        <div class="card-title">
                            <h3 class="card-label">Основная информация</h3>
                        </div>
                    </div>
                    <div class="card-body">
                        <!--begin::Example-->
                        <div class="example mb-10">

                            <div>
                                <label>Изображение профиля</label>

                                <div class="mb-3 mt-3">
                                    <img v-if="userDetails.image" :src="$urlBackEnd(userDetails.image)" class="avatar avatar-lg">
                                </div>

                                <button @click="deleteImage" v-if="userDetails.image" class="btn btn-danger btn-sm mb-4">Удалить изображение</button>

                                <input v-model="userDetails.image"
                                       class="form-control"
                                       :class="{'is-invalid': userDetails.image}"
                                       type="hidden"
                                       id="image"
                                       name="image"
                                       aria-describedby="basic-addon2"
                                       value="">

                                <vue-dropzone ref="myVueDropzone"
                                              id="dropzone"
                                              :options="dropzoneOptions"
                                              :useCustomSlot=true
                                              v-on:vdropzone-success="successDrop"
                                              v-on:vdropzone-max-files-exceeded="maxDrop"
                                >
                                    <div class="dropzone-custom-content">
                                        <b class="dropzone-custom-title">Выберите файл</b>
                                        <div class="subtitle">...или перетащите его сюда</div>
                                    </div>
                                </vue-dropzone>




                                    <b-form-group class="mt-5"
                                            id="input-group-1"
                                            description="Введите имя пользователя"
                                            label="Имя:"
                                            label-for="input-1"
                                    >
                                        <b-form-input
                                                id="input-1"
                                                v-model.trim="userDetails.name"
                                                :class="{'is-invalid': errors.name}"
                                                required
                                                placeholder="Введите имя"
                                        ></b-form-input>
                                        <div v-if="errors.name" class="invalid-feedback">{{errors.name[0]}}</div>
                                    </b-form-group>


                                    <b-button @click="changeProfile" ref="save_user" type="submit" variant="primary">Сохранить</b-button>

                            </div>
                        </div>
                        <!--end::Example-->
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card card-custom gutter-b">
                    <div class="card-header">
                        <div class="card-title">
                            <h3 class="card-label">Изменить пароль</h3>
                        </div>
                    </div>
                    <div class="card-body">
                        <!--begin::Example-->
                        <div class="example mb-10">

                            <div>

                                    <b-form-group
                                            id="input-group-2"
                                            description="Введите действующий пароль"
                                            label="Текущий пароль:"
                                            label-for="input-2"
                                    >
                                        <b-form-input
                                                id="input-2"
                                                v-model="password.oldPassword"
                                                :class="{'is-invalid': errors.oldPassword}"
                                                required
                                                type="password"
                                        ></b-form-input>
                                        <div v-if="errors.oldPassword" class="invalid-feedback">{{errors.oldPassword[0]}}</div>
                                    </b-form-group>

                                    <b-form-group
                                            id="input-group-2"
                                            description="Введите новый пароль"
                                            label="Новый пароль:"
                                            label-for="input-3"
                                    >
                                        <b-form-input
                                                id="input-3"
                                                v-model="password.newPassword"
                                                :class="{'is-invalid': errors.newPassword}"
                                                required
                                                type="password"
                                        ></b-form-input>
                                        <div v-if="errors.newPassword" class="invalid-feedback">{{errors.newPassword[0]}}</div>
                                    </b-form-group>

                                    <b-form-group
                                            id="input-group-2"
                                            description="Подтвердите пароль"
                                            label="Введите новый пароль еще раз:"
                                            label-for="input-4"

                                    >
                                        <b-form-input
                                                id="input-4"
                                                v-model="password.newPasswordConfirmation"
                                                :class="{'is-invalid': errors.newPasswordConfirmation}"
                                                required
                                                type="password"
                                        ></b-form-input>
                                        <div v-if="errors.newPasswordConfirmation" class="invalid-feedback">{{errors.newPasswordConfirmation[0]}}</div>
                                    </b-form-group>

                                    <b-button @click="changePassword" ref="save_password" type="submit" variant="primary">Изменить пароль</b-button>

                            </div>
                        </div>
                        <!--end::Example-->
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>

    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import { UPDATE_USER } from "@/core/services/store/auth.module";
    import { UPDATE_PASSWORD } from "@/core/services/store/auth.module";
    export default {
        name: "Account",
        components: {
            vueDropzone: vue2Dropzone
        },
        data() {
            return {
                state: true,
                password: {
                    oldPassword: '',
                    newPassword: '',
                    newPasswordConfirmation: ''
                },

                dismissSecs: 4,
                dismissCountDown: 0,
                showDismissibleAlert: false,
                variantAlert: '',
                textAlert: '',

                dropzoneOptions: {
                    url: this.$urlBackEnd('/api/v1/image/user/image'),
                    acceptedFiles: '.jpg, .jpeg, .png,',
                    thumbnailWidth: 200,
                    maxFilesize: 5,
                    maxFiles:1,
                    headers: { "Authorization": 'Bearer ' + localStorage.getItem('id_token') },
                    parallelUploads: 1,
                    createImageThumbnails: true,
                    uploadMultiple: false,
                },

            }
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Мой профиль" }]);

        },

        computed: {
            ...mapGetters({
                userDetails: 'currentUser',
                errors: 'errorsUser'
            }),

        },
        methods:{

            successDrop (file, response) {
                this.$refs.myVueDropzone.removeAllFiles();
                this.userDetails.image = response.original;
            },

            maxDrop (){
                console.log('Не более одного файла')
            },

            deleteImage(){
                this.userDetails.image = null;
            },

            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },

            showAlert(text, variant) {
                this.variantAlert = variant;
                this.dismissCountDown = this.dismissSecs;
                this.textAlert = text
            },

            changeProfile(){

                const submitButton = this.$refs["save_user"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");

                const id = this.userDetails.id;
                const image = this.userDetails.image;
                const name = this.userDetails.name;
                const email = this.userDetails.email;
                this.$store.dispatch(UPDATE_USER, {id, image, name, email})
                    .then(() => {
                        this.showAlert('Изменения успешно сохранены', 'success');
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger');
                        }
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                    });
            },

            changePassword(){
                const submitButton = this.$refs["save_password"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");

                const oldPassword = this.password.oldPassword;
                const newPassword = this.password.newPassword;
                const newPassword_confirmation = this.password.newPasswordConfirmation;

                this.$store.dispatch(UPDATE_PASSWORD, {oldPassword, newPassword, newPassword_confirmation})
                    .then(() =>  {
                        this.showAlert('Изменения успешно сохранены', 'success');
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
                    }).catch((response) => {
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
                    if (response && response.status === 500) {
                        if (response.data.success === false){
                            this.showAlert('Неверный пароль', 'danger');
                        }
                    } else if (response.status === 422){
                        this.showAlert('Заполните все поля', 'danger');
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>